/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const classifiedDocumentsByProject = /* GraphQL */ `
  query ClassifiedDocumentsByProject(
    $complianceType: String
    $limit: Int
    $nextToken: String
    $projectId: ID!
  ) {
    classifiedDocumentsByProject(
      complianceType: $complianceType
      limit: $limit
      nextToken: $nextToken
      projectId: $projectId
    ) {
      items {
        category
        complianceType
        confidence
        createdAt
        fileName
        id
        projectBuildingDataIds
        projectId
        requirementId
        storageLinkId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const classifiedDocumentsByRequirement = /* GraphQL */ `
  query ClassifiedDocumentsByRequirement(
    $limit: Int
    $nextToken: String
    $requirementId: ID!
  ) {
    classifiedDocumentsByRequirement(
      limit: $limit
      nextToken: $nextToken
      requirementId: $requirementId
    ) {
      items {
        category
        complianceType
        confidence
        createdAt
        fileName
        id
        projectBuildingDataIds
        projectId
        requirementId
        storageLinkId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companyMembersByCompany = /* GraphQL */ `
  query CompanyMembersByCompany(
    $companyId: ID!
    $filter: ModelCompanyMemberFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    companyMembersByCompany(
      companyId: $companyId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company {
          billingCycle
          createdAt
          createdByUserId
          domain
          id
          members {
            items {
              companyId
              createdAt
              email
              id
              role
              status
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          planKey
          planPriceId
          resources {
            items {
              companyId
              createdAt
              createdByUserId
              description
              id
              name
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          seatLimit
          stripeCustomerId
          stripeSubscriptionId
          subscriptionStatus
          updatedAt
          __typename
        }
        companyId
        createdAt
        email
        id
        role
        status
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companyMembersByUser = /* GraphQL */ `
  query CompanyMembersByUser(
    $filter: ModelCompanyMemberFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $userId: String!
  ) {
    companyMembersByUser(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      userId: $userId
    ) {
      items {
        company {
          billingCycle
          createdAt
          createdByUserId
          domain
          id
          members {
            items {
              companyId
              createdAt
              email
              id
              role
              status
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          planKey
          planPriceId
          resources {
            items {
              companyId
              createdAt
              createdByUserId
              description
              id
              name
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          seatLimit
          stripeCustomerId
          stripeSubscriptionId
          subscriptionStatus
          updatedAt
          __typename
        }
        companyId
        createdAt
        email
        id
        role
        status
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companyResourcesByCompany = /* GraphQL */ `
  query CompanyResourcesByCompany(
    $companyId: ID!
    $filter: ModelCompanyResourceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    companyResourcesByCompany(
      companyId: $companyId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company {
          billingCycle
          createdAt
          createdByUserId
          domain
          id
          members {
            items {
              companyId
              createdAt
              email
              id
              role
              status
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          planKey
          planPriceId
          resources {
            items {
              companyId
              createdAt
              createdByUserId
              description
              id
              name
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          seatLimit
          stripeCustomerId
          stripeSubscriptionId
          subscriptionStatus
          updatedAt
          __typename
        }
        companyId
        createdAt
        createdByUserId
        description
        id
        name
        type
        updatedAt
        url
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const complianceChecksByProject = /* GraphQL */ `
  query ComplianceChecksByProject(
    $filter: ModelComplianceCheckFilterInput
    $limit: Int
    $nextToken: String
    $projectId: ID!
    $sortDirection: ModelSortDirection
  ) {
    complianceChecksByProject(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      projectId: $projectId
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        estimatedCompletion
        id
        jobId
        processedDocuments
        projectId
        prompt
        selectedRequirementId
        status
        totalDocuments
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const complianceIssuesByCheck = /* GraphQL */ `
  query ComplianceIssuesByCheck(
    $checkId: ID!
    $filter: ModelComplianceIssueFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    complianceIssuesByCheck(
      checkId: $checkId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        aiAnalysis
        assignedTo
        categories
        checkId
        confidence
        createdAt
        deadline
        description
        expectedCompliance
        id
        identifiedIssue
        ncCode
        projectId
        references
        severity
        sourceDocuments
        status
        tags
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const complianceIssuesByProject = /* GraphQL */ `
  query ComplianceIssuesByProject(
    $filter: ModelComplianceIssueFilterInput
    $limit: Int
    $nextToken: String
    $projectId: ID!
    $sortDirection: ModelSortDirection
  ) {
    complianceIssuesByProject(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      projectId: $projectId
      sortDirection: $sortDirection
    ) {
      items {
        aiAnalysis
        assignedTo
        categories
        checkId
        confidence
        createdAt
        deadline
        description
        expectedCompliance
        id
        identifiedIssue
        ncCode
        projectId
        references
        severity
        sourceDocuments
        status
        tags
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCommunicationLink = /* GraphQL */ `
  query GetCommunicationLink($id: ID!) {
    getCommunicationLink(id: $id) {
      createdAt
      id
      name
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      billingCycle
      createdAt
      createdByUserId
      domain
      id
      members {
        items {
          company {
            billingCycle
            createdAt
            createdByUserId
            domain
            id
            members {
              nextToken
              __typename
            }
            name
            planKey
            planPriceId
            resources {
              nextToken
              __typename
            }
            seatLimit
            stripeCustomerId
            stripeSubscriptionId
            subscriptionStatus
            updatedAt
            __typename
          }
          companyId
          createdAt
          email
          id
          role
          status
          updatedAt
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      planKey
      planPriceId
      resources {
        items {
          company {
            billingCycle
            createdAt
            createdByUserId
            domain
            id
            members {
              nextToken
              __typename
            }
            name
            planKey
            planPriceId
            resources {
              nextToken
              __typename
            }
            seatLimit
            stripeCustomerId
            stripeSubscriptionId
            subscriptionStatus
            updatedAt
            __typename
          }
          companyId
          createdAt
          createdByUserId
          description
          id
          name
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      seatLimit
      stripeCustomerId
      stripeSubscriptionId
      subscriptionStatus
      updatedAt
      __typename
    }
  }
`;
export const getCompanyMember = /* GraphQL */ `
  query GetCompanyMember($id: ID!) {
    getCompanyMember(id: $id) {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      companyId
      createdAt
      email
      id
      role
      status
      updatedAt
      userId
      __typename
    }
  }
`;
export const getCompanyResource = /* GraphQL */ `
  query GetCompanyResource($id: ID!) {
    getCompanyResource(id: $id) {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      companyId
      createdAt
      createdByUserId
      description
      id
      name
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const getComplianceCheck = /* GraphQL */ `
  query GetComplianceCheck($id: ID!) {
    getComplianceCheck(id: $id) {
      createdAt
      estimatedCompletion
      id
      jobId
      processedDocuments
      projectId
      prompt
      selectedRequirementId
      status
      totalDocuments
      updatedAt
      userId
      __typename
    }
  }
`;
export const getComplianceIssue = /* GraphQL */ `
  query GetComplianceIssue($id: ID!) {
    getComplianceIssue(id: $id) {
      aiAnalysis
      assignedTo
      categories
      checkId
      confidence
      createdAt
      deadline
      description
      expectedCompliance
      id
      identifiedIssue
      ncCode
      projectId
      references
      severity
      sourceDocuments
      status
      tags
      updatedAt
      __typename
    }
  }
`;
export const getMyCompany = /* GraphQL */ `
  query GetMyCompany {
    getMyCompany {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      membership {
        company {
          billingCycle
          createdAt
          createdByUserId
          domain
          id
          members {
            items {
              companyId
              createdAt
              email
              id
              role
              status
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          planKey
          planPriceId
          resources {
            items {
              companyId
              createdAt
              createdByUserId
              description
              id
              name
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          seatLimit
          stripeCustomerId
          stripeSubscriptionId
          subscriptionStatus
          updatedAt
          __typename
        }
        companyId
        createdAt
        email
        id
        role
        status
        updatedAt
        userId
        __typename
      }
      __typename
    }
  }
`;
export const getParameter = /* GraphQL */ `
  query GetParameter($id: ID!) {
    getParameter(id: $id) {
      createdAt
      id
      name
      operator
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      subRequirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        requirement {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        requirementId
        title
        updatedAt
        __typename
      }
      subRequirementId
      type
      unit
      updatedAt
      value
      __typename
    }
  }
`;
export const getProject = /* GraphQL */ `
  query GetProject($id: ID!) {
    getProject(id: $id) {
      adjacentStreets
      averageGrade
      buildingClassification
      buildingFootprintArea
      buildingHeight
      buildingFootprintAreaExisting
      buildingFootprintAreaProposed
      grossFloorAreaExisting
      grossFloorAreaProposed
      communicationLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      companyId
      constructionType
      createdAt
      description
      entitiesData
      estimatedCompletion
      fireAlarm
      grossFloorArea
      hasBuildingCodeExtractions
      hazardousSubstances
      highBuilding
      id
      lastModified
      location
      majorOccupancy
      members {
        items {
          createdAt
          id
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          role
          updatedAt
          user {
            createdAt
            email
            id
            membershipId
            memberships {
              nextToken
              __typename
            }
            name
            updatedAt
            __typename
          }
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      occupancyCodes
      occupancyRegion
      occupancyTypes
      owner
      phase
      projectCategory
      requirements {
        items {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      roughConstructionBudget
      settings {
        autoSave
        createdAt
        id
        notifications
        owner
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        theme
        updatedAt
        __typename
      }
      siteArea
      sprinklerSystem
      standpipe
      startDate
      status
      storageLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      storeysAboveGrade
      storeysBelowGrade
      team {
        createdAt
        id
        name
        projects {
          items {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      teamId
      type
      updatedAt
      zoningDesignation
      __typename
    }
  }
`;
export const getProjectMember = /* GraphQL */ `
  query GetProjectMember($id: ID!) {
    getProjectMember(id: $id) {
      createdAt
      id
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      role
      updatedAt
      user {
        createdAt
        email
        id
        membershipId
        memberships {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        updatedAt
        __typename
      }
      userId
      __typename
    }
  }
`;
export const getProjectSettings = /* GraphQL */ `
  query GetProjectSettings($id: ID!) {
    getProjectSettings(id: $id) {
      autoSave
      createdAt
      id
      notifications
      owner
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      theme
      updatedAt
      __typename
    }
  }
`;
export const getRequirement = /* GraphQL */ `
  query GetRequirement($id: ID!) {
    getRequirement(id: $id) {
      createdAt
      description
      id
      parameters {
        items {
          createdAt
          id
          name
          operator
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          subRequirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          subRequirementId
          type
          unit
          updatedAt
          value
          __typename
        }
        nextToken
        __typename
      }
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      storageLinkId
      storageLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      subRequirements {
        items {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          title
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const getStorageLink = /* GraphQL */ `
  query GetStorageLink($id: ID!) {
    getStorageLink(id: $id) {
      createdAt
      id
      name
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const getSubRequirement = /* GraphQL */ `
  query GetSubRequirement($id: ID!) {
    getSubRequirement(id: $id) {
      createdAt
      description
      id
      parameters {
        items {
          createdAt
          id
          name
          operator
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          subRequirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          subRequirementId
          type
          unit
          updatedAt
          value
          __typename
        }
        nextToken
        __typename
      }
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      title
      updatedAt
      __typename
    }
  }
`;
export const getTeam = /* GraphQL */ `
  query GetTeam($id: ID!) {
    getTeam(id: $id) {
      createdAt
      id
      name
      projects {
        items {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      createdAt
      email
      id
      membershipId
      memberships {
        items {
          createdAt
          id
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          role
          updatedAt
          user {
            createdAt
            email
            id
            membershipId
            memberships {
              nextToken
              __typename
            }
            name
            updatedAt
            __typename
          }
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      updatedAt
      __typename
    }
  }
`;
export const listClassifiedDocuments = /* GraphQL */ `
  query ListClassifiedDocuments(
    $filter: ModelClassifiedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClassifiedDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        category
        complianceType
        confidence
        createdAt
        fileName
        id
        projectBuildingDataIds
        projectId
        requirementId
        storageLinkId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCommunicationLinks = /* GraphQL */ `
  query ListCommunicationLinks(
    $filter: ModelCommunicationLinkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunicationLinks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        id
        name
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        type
        updatedAt
        url
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCompanies = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCompanyMembers = /* GraphQL */ `
  query ListCompanyMembers(
    $filter: ModelCompanyMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanyMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        company {
          billingCycle
          createdAt
          createdByUserId
          domain
          id
          members {
            items {
              companyId
              createdAt
              email
              id
              role
              status
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          planKey
          planPriceId
          resources {
            items {
              companyId
              createdAt
              createdByUserId
              description
              id
              name
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          seatLimit
          stripeCustomerId
          stripeSubscriptionId
          subscriptionStatus
          updatedAt
          __typename
        }
        companyId
        createdAt
        email
        id
        role
        status
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCompanyResources = /* GraphQL */ `
  query ListCompanyResources(
    $filter: ModelCompanyResourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanyResources(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company {
          billingCycle
          createdAt
          createdByUserId
          domain
          id
          members {
            items {
              companyId
              createdAt
              email
              id
              role
              status
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          planKey
          planPriceId
          resources {
            items {
              companyId
              createdAt
              createdByUserId
              description
              id
              name
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          seatLimit
          stripeCustomerId
          stripeSubscriptionId
          subscriptionStatus
          updatedAt
          __typename
        }
        companyId
        createdAt
        createdByUserId
        description
        id
        name
        type
        updatedAt
        url
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listComplianceChecks = /* GraphQL */ `
  query ListComplianceChecks(
    $filter: ModelComplianceCheckFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComplianceChecks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        estimatedCompletion
        id
        jobId
        processedDocuments
        projectId
        prompt
        selectedRequirementId
        status
        totalDocuments
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listComplianceIssues = /* GraphQL */ `
  query ListComplianceIssues(
    $filter: ModelComplianceIssueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComplianceIssues(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        aiAnalysis
        assignedTo
        categories
        checkId
        confidence
        createdAt
        deadline
        description
        expectedCompliance
        id
        identifiedIssue
        ncCode
        projectId
        references
        severity
        sourceDocuments
        status
        tags
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listParameters = /* GraphQL */ `
  query ListParameters(
    $filter: ModelParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listParameters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        id
        name
        operator
        requirement {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        requirementId
        subRequirement {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          title
          updatedAt
          __typename
        }
        subRequirementId
        type
        unit
        updatedAt
        value
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProjectMembers = /* GraphQL */ `
  query ListProjectMembers(
    $filter: ModelProjectMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        id
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        role
        updatedAt
        user {
          createdAt
          email
          id
          membershipId
          memberships {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          updatedAt
          __typename
        }
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProjectSettings = /* GraphQL */ `
  query ListProjectSettings(
    $filter: ModelProjectSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        autoSave
        createdAt
        id
        notifications
        owner
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        theme
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProjects = /* GraphQL */ `
  query ListProjects(
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRequirements = /* GraphQL */ `
  query ListRequirements(
    $filter: ModelRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequirements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStorageLinks = /* GraphQL */ `
  query ListStorageLinks(
    $filter: ModelStorageLinkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStorageLinks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        id
        name
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        requirement {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        requirementId
        type
        updatedAt
        url
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSubRequirements = /* GraphQL */ `
  query ListSubRequirements(
    $filter: ModelSubRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubRequirements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        requirement {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        requirementId
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTeams = /* GraphQL */ `
  query ListTeams(
    $filter: ModelTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        id
        name
        projects {
          items {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        email
        id
        membershipId
        memberships {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const projectMembersByProject = /* GraphQL */ `
  query ProjectMembersByProject(
    $limit: Int
    $nextToken: String
    $projectId: ID!
  ) {
    projectMembersByProject(
      limit: $limit
      nextToken: $nextToken
      projectId: $projectId
    ) {
      items {
        createdAt
        id
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        role
        updatedAt
        user {
          createdAt
          email
          id
          membershipId
          memberships {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          updatedAt
          __typename
        }
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const projectMembersByUser = /* GraphQL */ `
  query ProjectMembersByUser($limit: Int, $nextToken: String, $userId: ID!) {
    projectMembersByUser(
      limit: $limit
      nextToken: $nextToken
      userId: $userId
    ) {
      items {
        createdAt
        id
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        role
        updatedAt
        user {
          createdAt
          email
          id
          membershipId
          memberships {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          updatedAt
          __typename
        }
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const storageLinksByRequirement = /* GraphQL */ `
  query StorageLinksByRequirement(
    $limit: Int
    $nextToken: String
    $requirementId: ID!
  ) {
    storageLinksByRequirement(
      limit: $limit
      nextToken: $nextToken
      requirementId: $requirementId
    ) {
      items {
        createdAt
        id
        name
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        requirement {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        requirementId
        type
        updatedAt
        url
        __typename
      }
      nextToken
      __typename
    }
  }
`;
